export const SET_SETTINGS = "set_settings";
export const SET_USER = "set_user";
export const SET_WEIXIN_OAUTH = "set_weixin_oauth";
export const SET_PATIENT = "set_patient";
